import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NgForm, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendService } from '../../core/backend.service';
import { Cliente } from '../../cliente/cliente.model';
import { MatChipInputEvent, MatAutocompleteSelectedEvent } from '@angular/material';
import { SnackService } from '../../shared-services/snack.service';
import { ClienteService } from '../../core/cliente.service';
import { Parametric } from '../../cliente/parametric.model';
import { Observable } from 'rxjs/Observable';
import { ENTER } from '@angular/cdk/keycodes';
import { DialogService } from '../modals/dialog.service';
import { ApiService } from '../../core/api.service';
import { EstadoCliente } from '../../cliente/estadoCliente.model';
import { AprobacionCliente } from './aprobacionCliente.model';
import { OperationalParametric } from '../../cliente/operationalParametric.model';
import { TipoMoneda } from '../../cliente/tipoMoneda.model';
import { MontoCompra } from '../../cliente/montoCompra.model';

@Component({
  selector: 'app-validar-documentacion',
  templateUrl: './validar-documentacion.component.html',
  styleUrls: ['./validar-documentacion.component.scss']
})
export class ValidarDocumentacionComponent implements OnInit {
  @ViewChild('validacionDocForm') public validacionDocForm: NgForm;
  EstadoCliente = new EstadoCliente();
  cliente: Cliente;
  validationFail: boolean;
  private motivoError: string;
  validacion: AprobacionCliente;
  private tiposMonedas: TipoMoneda[];
  lotesDocumentacion: AprobacionCliente[] = [];
  private nivelesList: Observable<Parametric[]>;
  private _selectedNivel: Parametric[] = [];
  private addOnBlur = false;
  private separatorKeysCodes: number[] = [ENTER];
  private toppings = new FormControl();
  urlBack: string;
  @ViewChild('fruitInput') fruitInput: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private backendService: BackendService,
    private apiService: ApiService,
    private renderer: Renderer2,
    private snackService: SnackService,
    clienteService: ClienteService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.validacion = data.validarDocumentacion.validacion;
      if (this.validacion.id) {
        this.validacion.enviarNotificacion = true;
        for (const documento of this.validacion.documentos) {
          if (!documento.motivoRechazo) {
            documento.motivoRechazo = new OperationalParametric();
          }
        }
      }

      this.route.params.subscribe(params => {
        this.urlBack = '/clientes/detalles/' + params.id;
      });

      this.cliente = data.validarDocumentacion.cliente;
      this.getInfoAprobaciones(this.cliente.id);
      this.validacion.montoCompra = this.cliente.montoCompraActual ? this.cliente.montoCompraActual : new MontoCompra();
    });
    this.getNivelesList();
    this.getTiposMonedas();
  }

  async getInfoAprobaciones(clienteId: number) {
    this.lotesDocumentacion = await this.backendService.get
      (AprobacionCliente, Cliente.path + 'estados_aprobacion_rechazo/' + clienteId, null).toPromise();
  }

  async getTiposMonedas() {
    this.tiposMonedas = await this.apiService.get(TipoMoneda, TipoMoneda.path, null).toPromise();
  }

  async getNivelesList() {
    this.nivelesList = this.apiService.get(Parametric, Parametric.path + 'niveles_aprobacion/', null);
  }

  updateMotivoRechazo(index: number, value: number) {
    this.validacion.documentos[index].estadoDocumentacion.id = value;
    this.createStringMotivoRechazo();
  }

  createStringMotivoRechazo() {
    let allValidos = true;
    this.validacion.motivoRechazo = 'Estimado cliente,\n\nTe informamos que: \n\n';
    for (const documento of this.validacion.documentos) {
      if (documento.estadoDocumentacion.id === 3) {
        allValidos = false;
        if (!documento.motivoRechazo.id) {
          this.validacion.motivoRechazo +=
          'El documento ' + documento.path + ' de tipo ' + documento.tipoDocumentacion.description +
          ' no es válido.\n';
        } else {
          this.validacion.motivoRechazo +=
          'El documento ' + documento.path + ' de tipo ' + documento.tipoDocumentacion.description +
          ' no es válido por el motivo: \"' + documento.motivoRechazo.description + '\".\n';
        }
      }
    }
    if (allValidos) {
      this.validacion.motivoRechazo = '';
    }
  }

  cancelar() {
    this.router.navigate(['/clientes/detalles/' + this.cliente.id]);
  }
  async aprobarRechazarCliente() {
    this.snackService.spinner(true);
    try {
      await this.backendService.create(Cliente.path + 'aprobar_rechazar/' + this.cliente.id, this.validacion);
      this.router.navigate(['/clientes/detalles/' + this.cliente.id]);
      if (this.validacion.aprobado) {
        this.snackService.success('Cliente aprobado satisfactoriamente');
      } else {
        this.snackService.success('Cliente rechazado satisfactoriamente');
      }
    } catch (ex) {
      if (ex[0]) {
        this.snackService.error(ex[0].details);
      } else if (ex.errors) {
        this.snackService.error(ex.errors[0].defaultMessage);
      } else {
        this.snackService.error(ex.message);
      }
    } finally {
      this.snackService.spinner(false);
    }
  }

  async guardarCliente() {
    this.snackService.spinner(true);
    try {
      await this.backendService.create(Cliente.path + 'save_info_aprobacion/' + this.cliente.id, this.validacion);
      this.router.navigate(['/clientes/detalles/' + this.cliente.id]);
      this.snackService.success('Cliente guardado satisfactoriamente');
    } catch (ex) {
      if (ex[0]) {
        this.snackService.error(ex[0].details);
      } else if (ex.errors) {
        this.snackService.error(ex.errors[0].defaultMessage);
      } else {
        this.snackService.error(ex.message);
      }
    } finally {
      this.snackService.spinner(false);
    }
  }

  async showFile(id: number) {
  }
  private openWindow(data) {
    try {
      const blob = new Blob([data], { type: data.type });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '', 'width=400, height=400');
    } catch (ex) {
      console.log(ex);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {

    const index = this.validacion.nivelesAprobacion.indexOf(event.option.value);
    if (index >= 0) {
      return;
    }
    this.validacion.nivelesAprobacion.push(event.option.value);
    this.fruitInput.nativeElement.value = '';
    this.toppings.setValue(null);
    // this.renderer.invokeElementMethod(this.fruitInput.nativeElement, 'blur', []);
    this.filter();
  }

  confirmAprobar() {
    this.validationFail = false;
    for (const documento of this.validacion.documentos) {
      if (documento.estadoDocumentacion.id !== 2) {
        this.validationFail = true;
        this.motivoError = 'Todos los documentos deben ser válidos para aprobar el cliente';
        break;
      }
    }
    if (!this.validationFail) {
      this.dialogService.confirm('Aprobar',
      '¿Está seguro que desea aprobar al cliente?')
        .then( res => {
          if (res) {
            this.validacion.aprobado = true;
            this.aprobarRechazarCliente();
          }
        });
    }
  }
  confirmRechazar() {
    this.validationFail = true;
    this.motivoError = 'Al menos un documento tiene que ser no válido para rechazar el cliente';
    for (const documento of this.validacion.documentos) {
      if (documento.estadoDocumentacion.id === 3) {
        this.validationFail = false;
        break;
      }
    }
    if (!this.validationFail) {
      this.dialogService.confirm('Rechazar',
        '¿Está seguro que desea rechazar al cliente?')
        .then( res => {
          if (res) {
            this.validacion.aprobado = false;
            this.aprobarRechazarCliente();
          }
        });
    }
  }
  confirmGuardar() {
    this.validationFail = true;
    this.motivoError = 'Al menos un documento tiene que ser no válido para no confirmar el cliente';
    for (const documento of this.validacion.documentos) {
      if (documento.estadoDocumentacion.id === 3) {
        this.validationFail = false;
        break;
      }
    }
    if (!this.validationFail) {
      this.dialogService.confirm('Actualizar',
      '¿Está seguro que desea actualizar la información del cliente?')
        .then( res => {
          if (res) {
            this.guardarCliente();
          }
        });
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
  }

  onSelect(event: any) {
    for (const documento of this.validacion.documentos) {
      if (documento.id === event.id) {
        documento.motivoRechazo = event.motivoRechazo;
        this.createStringMotivoRechazo();
      }
    }
  }

  remove(nivel: Parametric): void {

    const index = this.validacion.nivelesAprobacion.indexOf(nivel);
    if (index >= 0) {
      this.validacion.nivelesAprobacion.splice(index, 1);
    }
    this.filter();
  }

  public nivelSelected(nivel: Parametric): boolean {
    for (const nivelCliente of this.validacion.nivelesAprobacion) {
      if (nivel.id === nivelCliente.id) {
        return true;
      }
    }
    return false;
  }

  private filter() {
    this.nivelesList
    .map(r => r.filter(p => this._selectedNivel.indexOf(p) === 0));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/validar-documentacion/validar-documentacion.component.ts